import { baseStoreCreator } from '@/utils/store';

export interface ClaimCreating {
  isCreatingClaim?: boolean;
  isClaimCreated?: boolean;
}

export const DEFAULT_VALUES: ClaimCreating = {
  isCreatingClaim: false,
  isClaimCreated: false,
};

export const useClaimCreatingStore = baseStoreCreator<ClaimCreating>(
  DEFAULT_VALUES,
);

export default useClaimCreatingStore;
